import * as React from "react";
import { EditorialModel } from "src/typings/microserviceModels/content-flex-module";
import { UitkText } from "uitk-react-text";
import { DecorateEditorialHtml } from "../../../../ContentUtilities";
import { UitkSpacing } from "uitk-react-spacing";

export const CitifaqHeader = (props: { items: EditorialModel[] }) => {
  const { items } = props;
  if (items.length !== 1) {
    return null;
  }

  return (
    <div>
      <UitkText align="center" size={600} weight="bold">
        <UitkSpacing padding={{ blockend: "six", blockstart: "twelve" }}>
          <div>
            <DecorateEditorialHtml text={items[0].text} />
          </div>
        </UitkSpacing>
      </UitkText>
    </div>
  );
};

export default CitifaqHeader;
